import { FC, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
    AppContextType,
    FieldContextType,
    ListViewContext,
    ListViewContextType,
    ListViewDataModel,
    ListViewsContextType,
    SectionCompleteContextType,
    SectionErrorContextType,
    StateContext,
    StepToSectionContextType,
} from "../../context/ApplicationContext";
import { useAppSelector } from "../../store/hooks";
import PPDialog from "../UI/PPDialog";
import PPStepper from "../UI/PPStepper";
import { SectionConfiguration } from "../model/form-configuration";

const StepperLayout: FC<{ children: JSX.Element[] }> = ({ children }) => {
  const { form } = useAppSelector((state) => state.form);
  const [openDialog, setOpenDialog] = useState(false);

  const initListViewContext = (): ListViewsContextType => {
    const lstCtx: ListViewsContextType = {};
    form.sections.forEach((section) => {
      const initLstCtx: ListViewContextType = {
        dataModel: {uiModel: [], submitRecordModel: []} as ListViewDataModel,
        errorState: { state: false, message: undefined },
        editRow: undefined,
        expanded: true,
        minimumNumberOfRows: 0,
      };
      lstCtx[section.id] = initLstCtx;
    });
    return lstCtx;
  };

  const [listViewsState, setListViewsState]: [
    ListViewsContextType,
    React.Dispatch<React.SetStateAction<ListViewsContextType>>
  ] = useState(initListViewContext);

  const initAppContext = (): AppContextType => {
    const errorState: SectionErrorContextType = {};
    const completeState: SectionCompleteContextType = {};
    const stepToSection: StepToSectionContextType = {};
    const fieldState: FieldContextType = {};
    form.sections.forEach((section: SectionConfiguration, index: number) => {
      stepToSection[index] = section.id;
      completeState[section.id] = false;
      errorState[section.id] = true;
      if (section.fields)
        section.fields.forEach((field) => {
          fieldState[field.id] = true;
        });
      else if (section.forms) {
        section.forms.forEach((form) => {
          form.sections[0].fields?.forEach((innerField) => {
            fieldState[innerField.id] = true;
          });
        });
      }
    });

    const appContext: AppContextType = {
      sectionState: {
        errorState: errorState,
        hideState: {},
        completeState: completeState,
        stepToSection: stepToSection,
      },
      fieldState: fieldState,
      fieldHide: {},
      fieldDisable: {},
      checkboxChecked: {
        checked: {},
      },
    };

    return appContext;
  };

  const [applicationContext, setApplicationContext]: [
    AppContextType,
    React.Dispatch<React.SetStateAction<AppContextType>>
  ] = useState(initAppContext);

  const methods = useForm({ defaultValues: {} });

  return (
    <ListViewContext.Provider value={{ listViewsState, setListViewsState }}>
      <StateContext.Provider
        value={{ applicationContext, setApplicationContext }}
      >
        <FormProvider {...methods}>
          <PPStepper sections={form.sections} setDialogState={setOpenDialog}>
            {children}
          </PPStepper>
          <PPDialog
            title="Confirmation Dialog"
            state={openDialog}
            setState={setOpenDialog}
          />
        </FormProvider>
      </StateContext.Provider>
    </ListViewContext.Provider>
  );
};

export default StepperLayout;
//StepperLayout.whyDidYouRender = true;
